import createAction from '@clearscore/helpers.create-action';
import createRequestPayload from '@clearscore/helpers.create-request-payload';
import getEnv from '@clearscore/helpers.envs';

import { getWebviewAppVersion } from './utils';
import {
    MARKET_CHECK,
    MARKET_SET_LOCALES,
    MARKET_SET_ACTIVE_LOCALE,
    MARKET_SET_MARKETS,
    MARKET_SET_ACTIVE_MARKET,
    MARKET_SET_ENVS,
    MARKET_SET_GEO_MARKET,
    MARKET_FETCH_CONFIG,
    MARKET_FETCH_STATIC_CONFIG,
} from './types';

export const check = () =>
    createAction(MARKET_CHECK, createRequestPayload('international', '/login-service/v2/locate'));

export const setGeoMarket = (geoMarket) => ({ type: MARKET_SET_GEO_MARKET, payload: geoMarket });

export const setMarkets = (markets) => ({ type: MARKET_SET_MARKETS, payload: markets });

export const setLocales = (locales) => ({ type: MARKET_SET_LOCALES, payload: locales });

export const setMarketsEnvs = (envs) => ({ type: MARKET_SET_ENVS, payload: envs });

export const setActiveMarket = (market) => createAction(MARKET_SET_ACTIVE_MARKET, { market });

export const fetchMarketConfig = (market, { useRenderEngineV4 } = { useRenderEngineV4: false }) => {
    const meta = {
        market,
    };
    const timeout = getEnv('MARKET_REQUEST_TIMEOUT') || 1000;
    const appVersion = getWebviewAppVersion();

    const headers = {
        'x-app-id': getEnv('APP'),
        'x-market-id': market,
        ...(appVersion && { 'x-cs-app-version': appVersion }),
    };

    if (useRenderEngineV4)
        return createAction(
            MARKET_FETCH_CONFIG,
            createRequestPayload(
                'international',
                '/render-engine-local/v1/config',
                'get',
                null,
                meta,
                headers,
                timeout,
            ),
        );

    return createAction(
        MARKET_FETCH_CONFIG,
        createRequestPayload('flux', '/config', 'get', null, meta, headers, timeout),
    );
};

export const fetchStaticMarketConfig = (market) =>
    createAction(MARKET_FETCH_STATIC_CONFIG, {
        ...createRequestPayload(
            'renderEngine',
            `${market}.json?version=${getEnv(`${market.toUpperCase()}_VERSION`) || '1'}`,
        ),
        market,
    });

export const setActiveLocale = (activeLocale) => createAction(MARKET_SET_ACTIVE_LOCALE, activeLocale);
